import { EmailConfirmation } from '@unistocks/features/authentication/email-confirmation';
import { t } from '@unistocks/shared/localization/index.ts';
import { useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

export default function EmailConfirmedScreen() {
  const { success } = useLocalSearchParams<{ success: string }>();

  return (
    <>
      <Head>
        <title>{t('::EmailConfirmation')}</title>
      </Head>
      <EmailConfirmation success={success} />
    </>
  );
}
